import {Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-deployments',
  templateUrl: './deployments.component.html',
  styleUrls: ['./deployments.component.scss']
})
export class DeploymentsComponent implements OnInit {

  constructor(
  private route: ActivatedRoute,
  private router: Router,) {
  }

  ngOnInit() {
    this.deploymentNumber$ = this.route.paramMap.pipe(switchMap((params: ParamMap) => {
      if (typeof params['deploymentNumber'] == 'number') {
        return of(params['deploymentNumber']) as Observable<number>;
      } else {
        throw TypeError('deploymentNumber is not a number');
      }
    }));
  }

  allVisited = false;
  deploymentNumber$: Observable<number>;
}
